import { graphQlClient } from '@config/graphqlClient';
import SuperAdminNotificationRecipientGraphQL from '@graphql/superAdminNotificationRecipient.queries';
import {
  SuperAdminNotificationRecipient,
  SuperAdminNotificationRecipientCreateInput,
  SuperAdminNotificationRecipientUpdateInput,
} from '@models/superAdminNotificationRecipient.model';

interface GetSuperAdminNotificationRecipientsResponse {
  getSuperAdminNotificationRecipients: SuperAdminNotificationRecipient[];
}
interface CreateSuperAdminNotificationRecipientResponse {
  createSuperAdminNotificationRecipient: SuperAdminNotificationRecipient;
}
interface UpdateSuperAdminNotificationRecipientResponse {
  updateSuperAdminNotificationRecipient: SuperAdminNotificationRecipient;
}
interface DeleteSuperAdminNotificationRecipientResponse {
  deleteSuperAdminNotificationRecipient: boolean;
}

export const superAdminNotificationRecipientService = {
  async getRecipients(): Promise<SuperAdminNotificationRecipient[]> {
    const data: GetSuperAdminNotificationRecipientsResponse = await graphQlClient.request(
      SuperAdminNotificationRecipientGraphQL.queries.getSuperAdminNotificationRecipients,
    );
    return data.getSuperAdminNotificationRecipients || [];
  },

  async createRecipient(
    input: SuperAdminNotificationRecipientCreateInput,
  ): Promise<SuperAdminNotificationRecipient> {
    const data: CreateSuperAdminNotificationRecipientResponse = await graphQlClient.request(
      SuperAdminNotificationRecipientGraphQL.mutations.createSuperAdminNotificationRecipient,
      { input },
    );
    return data.createSuperAdminNotificationRecipient;
  },

  async updateRecipient(
    input: SuperAdminNotificationRecipientUpdateInput,
  ): Promise<SuperAdminNotificationRecipient> {
    const data: UpdateSuperAdminNotificationRecipientResponse = await graphQlClient.request(
      SuperAdminNotificationRecipientGraphQL.mutations.updateSuperAdminNotificationRecipient,
      { input },
    );
    return data.updateSuperAdminNotificationRecipient;
  },

  async deleteRecipient(id: string): Promise<boolean> {
    const data: DeleteSuperAdminNotificationRecipientResponse = await graphQlClient.request(
      SuperAdminNotificationRecipientGraphQL.mutations.deleteSuperAdminNotificationRecipient,
      { id },
    );
    return data.deleteSuperAdminNotificationRecipient;
  },
};

export default superAdminNotificationRecipientService;
